<template>
  <el-dialog
    :title="dialogTitle"
    visible
    :close-on-click-modal="false"
    width="720px"
    @close="onClose"
  >
    <div class="das-form-container">
      <section class="mb-20">
        <!-- <div class="das-form-title-container">
            <div class="das-form-title">
              <span class="main-title p-0">Thông tin kiểm toán</span>
            </div>
          </div> -->
        <div class="das-info-title mt-0">Thông tin kiểm toán</div>

        <InfoList :columns="2" class="profile__info-list">
          <InfoListLabel style="width: 80px">Thu ngân</InfoListLabel>
          <InfoListValue style="min-width: 270px">
            {{ revenueData?.cashier_username ?? '' }}
          </InfoListValue>
          <InfoListLabel style="">Kiểm toán</InfoListLabel>
          <InfoListValue>
            {{ revenueData?.accountant_username ?? '' }}
          </InfoListValue>
          <InfoListLabel style="">Ngày</InfoListLabel>
          <InfoListValue>{{ $displayDate(revenueData?.date) }}</InfoListValue>
        </InfoList>
      </section>

      <validation-observer ref="formValidator">
        <div class="das-info-title mt-0">Thông tin tài khoản</div>

        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">Tài khoản</div>
                <validation-provider
                  rules="required"
                  :name="$t('field.account')"
                >
                  <input v-model="formData.username" type="text" />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">Mật khẩu</div>
                <div class="password-input-container">
                  <validation-provider
                    :name="$t('field.password')"
                    rules="required"
                    vid="password"
                  >
                    <input
                      v-model="formData.password"
                      :type="showPwd ? 'text' : 'password'"
                    />
                  </validation-provider>
                  <div
                    class="eye-password"
                    :class="[showPwd ? 'show' : 'hide']"
                    @click="showPwd = !showPwd"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button class="btn primary small" @click="fnSubmit">
          {{ $t('button.confirm') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { CASHIER_CONFIRM_TYPE, CONFIRM_STATUS } from '../constant'
import { updateAccountRevenueByCashier } from '@/api/cashier_service/audit'

export default {
  props: {
    revenueData: {
      type: Object,
      default: () => ({})
    },
    type: {
      default: null
      /** ENUMS:
       * - CASHIER_CONFIRM_TYPE.CONFIRM
       * - CASHIER_CONFIRM_TYPE.REPORT_WRONG
       */
    }
  },
  data() {
    return {
      formData: {
        username: null,
        password: null
      },
      showPwd: false
    }
  },
  computed: {
    CASHIER_CONFIRM_TYPE() {
      return CASHIER_CONFIRM_TYPE
    },
    dialogTitle() {
      let title = ''
      switch (this.type) {
        case CASHIER_CONFIRM_TYPE.CONFIRM:
          title = 'Xác nhận kiểm toán'
          break
        case CASHIER_CONFIRM_TYPE.REPORT_WRONG:
          title = 'Phản hồi kiểm toán sai'
          break
        default:
          break
      }
      return title
    }
  },

  mounted() {},

  destroyed() {
    this.resetDialog()
  },

  methods: {
    resetDialog() {
      this.formData = {
        username: null,
        password: null
      }
    },

    onClose() {
      this.$emit('close')
    },
    async fnSubmit() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      const payload = {
        ...this.formData,
        new_status:
          this.type === CASHIER_CONFIRM_TYPE.CONFIRM
            ? CONFIRM_STATUS.CONFIRMED
            : CONFIRM_STATUS.RESPONSE_WRONG,
        old_status: this.revenueData.status,
        id: this.revenueData.id,
        cashier_id: this.revenueData.cashier_id
      }

      updateAccountRevenueByCashier(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('close')
          this.$emit('resetData')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.password-input-container {
  position: relative;

  input {
    padding-right: 36px;
  }

  .eye-password {
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% + 2px));
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &.hide {
      // background: url('/src/styles/images/mci_eye_slash_icon.svg') no-repeat;
      background: url('../../../../styles/images/svg/mci_eye_slash_icon.svg')
        no-repeat;
    }

    &.show {
      background: url('../../../../styles/images/svg/mci_eye_icon.svg')
        no-repeat;
    }
  }
}
</style>
